"use client";

import { trackEvent } from "@/src/lib/gtm-track";

export function HeroCtaWrapper({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <a
      href={href}
      className={className}
      onClick={() => trackEvent({ name: "click_whatsapp", params: { type: "hero_cta" } })}
    >
      {children}
    </a>
  );
}
